module.exports = __webpack_public_path__ + "media/images/pin blanc-b48dba1699e13652dc0754576d5bbc47.svg";